import React, { useState } from 'react';
import { Button, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import callApi from '../common/APIClient';

function Classify() {
  const [selectedFile, setSelectedFile] = useState(null);
  const [isUploading, setIsClassifying] = useState(false);
  const [uploadStatus, setClassifyStatus] = useState('');

  // Handle file selection
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
    }
  };

  const [labels, setLabels] = useState([]);
  const [scores, setScores] = useState([]);

  // Handle file upload to REST API
  const handleFileUpload = async () => {
    if (!selectedFile) {
      alert('Please select a file before classifying.');
      return;
    }

    const formData = new FormData();
    formData.append('file', selectedFile);

    setIsClassifying(true);
    setClassifyStatus('Classifying...');

    try {
      const response = await callApi({
        url: "/classify/",
        method: "POST",
        params: {}
      });
      
      setClassifyStatus('Classify successful!');

      const labelsVal = response.data.labels;
      console.log('Labels Value', labelsVal);

      const scoresVal = response.data.scores;
      console.log('Scores Value', scoresVal);

      setLabels(labelsVal);
      setScores(scoresVal);

      console.log('Server Response:', response.data);

    } catch (error) {
      setClassifyStatus('Classify failed.');
      console.error('Classify error:', error);
    } finally {
      setIsClassifying(false);
    }
  };

  return (
    <Grid container spacing={2}>
        <Grid size={12}>
            <Typography variant="h6">Classify Document</Typography>
        </Grid>
        <Grid size={4}>
            {/* File input */}
            <Button variant="contained" component="label">
                Choose File
                <input type="file" hidden onChange={handleFileChange} />
            </Button>
        </Grid>
        <Grid size={8}>
            {selectedFile && (
                <Typography variant="body2" sx={{ marginTop: 2 }}>
                Selected file: {selectedFile.name}
                </Typography>
            )}
        </Grid>
        <Grid size={4}>
            {/* Upload Button */}
            <Button
                variant="contained"
                color="primary"
                onClick={handleFileUpload}
                disabled={isUploading || !selectedFile}
                sx={{ marginTop: 2 }}
            >
                Run Classifier
            </Button>
        </Grid>
        <Grid size={8}>
            {/* Upload Status */}
            {uploadStatus && (
                <Typography variant="body2" sx={{ marginTop: 2 }}>
                {uploadStatus}
                </Typography>
            )}
        </Grid> 
        <Grid size={12}>
            {/* Scores */}
            {uploadStatus && (
                <Typography variant="body2" sx={{ marginTop: 2 }}>
                <div className="p-4">
                  <h2 className="text-xl font-bold mb-2">Key-Value Pairs</h2>
                  <table className="border-collapse border border-gray-400">
                    <tbody>
                      {labels.map((label, index) => (
                        <tr key={index} className="border border-gray-400">
                          <td className="p-2 border border-gray-400 font-semibold">{label}</td>
                          <td className="p-2 border border-gray-400">{scores[index]}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                </Typography>
            )}
        </Grid>       
    </Grid>
  );
}

export default Classify;
